import { render } from "./GeneralUserTermsContent.vue?vue&type=template&id=4ce98e26&scoped=true"
const script = {}

import "./GeneralUserTermsContent.vue?vue&type=style&index=0&id=4ce98e26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce98e26"]])

export default __exports__